import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  Label,
  SelectNative,
  SelectNativeOption,
} from '@americanexpress/dls-react';
import TravelCreditDetail from './TravelCreditDetail';

const MultipleTravelCredit = ({
  selectedAccountData,
  hasTravelCreditCenturionCardArt,
}) => {
  const { formatMessage } = useIntl();
  const { travelCredit = [] } = selectedAccountData;
  const [selectedTravelCreditIndex, setSelectedTravelCreditIndex] = useState(0);
  const selectedTravelCredit = travelCredit[selectedTravelCreditIndex] || {};
  return (
    <div className="margin-b">
      <Label htmlFor="multipleTravelCreditDropdown">
        {formatMessage({ id: 'travelCreditTab.heading' }).toUpperCase()}
      </Label>
      <SelectNative
        id="multipleTravelCreditDropdown"
        value={selectedTravelCreditIndex.toString()}
        onChange={(event) => setSelectedTravelCreditIndex(Number.parseInt(event.target.value, 10))}
      >
        {travelCredit.map((credit, index) => (
          <SelectNativeOption value={index.toString()} key={credit.name}>
            {credit.name}
          </SelectNativeOption>
        ))}
      </SelectNative>
      <TravelCreditDetail
        selectedAccountData={selectedAccountData}
        selectedTravelCredit={selectedTravelCredit}
        hasTravelCreditCenturionCardArt={hasTravelCreditCenturionCardArt}
      />
    </div>
  );
};

MultipleTravelCredit.propTypes = {
  selectedAccountData: PropTypes.shape({
    displayAccountNumber: PropTypes.string,
    cardArtCdnLink: PropTypes.string,
    travelCredit: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        marketingText: PropTypes.string,
        callToActionText: PropTypes.string,
        landingPage: PropTypes.string,
        expiry: PropTypes.string,
      })
    ),
  }),
  hasTravelCreditCenturionCardArt: PropTypes.bool.isRequired,
};

export default MultipleTravelCredit;
